import { render } from "./SelectFeatures.vue?vue&type=template&id=3a78d5aa&scoped=true"
import script from "./SelectFeatures.vue?vue&type=script&lang=js"
export * from "./SelectFeatures.vue?vue&type=script&lang=js"

import "./SelectFeatures.vue?vue&type=style&index=0&id=3a78d5aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a78d5aa"]])

export default __exports__